<ng-container *ngIf="filter">
	<span>{{ filter.label }}</span>
	<div class="filter-container" *ngFor="let item of filter.getValues(); trackBy: trackByFunc">
		<mat-icon color="accent" mat-ripple class="circle-icon-remove" svgIcon="md:remove" (click)="removeValue(item)"></mat-icon>
		<copo-product-suggestive-item-filter [placeholder]="filter.placeholder" [filterValue]="item" [additionalInput]="additionalInput"></copo-product-suggestive-item-filter>
	</div>
</ng-container>
